<ngb-alert [type]="type" (closed)="onClose()" (click)="navigateToReport(id)">
    {{ message }}
</ngb-alert>
